import { Button, Result } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import React from "react";

const NoFound = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="404"
      subTitle="对不起, 你访问的页面不存在"
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          返回首页
        </Button>
      }
    ></Result>
  );
};

export default NoFound;
